import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import BillingDashboard from '../components/billing/BillingDashboard';
import CreditPackages from '../components/billing/CreditPackages';
import DynamicCreditExplanation from '../components/pricing/DynamicCreditExplanation';

const BillingPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="p-6 bg-gray-50 dark:bg-gray-900 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Tabs value={activeTab} onValueChange={setActiveTab} defaultValue="overview" className="space-y-8">
              <div className="border-b border-gray-200">
                <TabsList className="grid w-full grid-cols-2 lg:w-auto lg:grid-cols-2">
                  <TabsTrigger value="overview" className="px-6 py-3">
                    Billing Overview
                  </TabsTrigger>
                  <TabsTrigger value="credits" className="px-6 py-3">
                    Buy Credits
                  </TabsTrigger>
                </TabsList>
              </div>

              <TabsContent value="overview" className="space-y-6">
                <BillingDashboard />
              </TabsContent>

              <TabsContent value="credits" className="space-y-6">
                <div className="text-center mb-8">
                  <h2 className="text-3xl font-bold text-black dark:text-white mb-4">
                    Purchase Credits
                  </h2>
                  <p className="text-xl text-black dark:text-gray-300 max-w-2xl mx-auto">
                    Top up your account with credits to unlock AI-powered features like image generation, 3D modeling, and AR creation.
                  </p>
                </div>
                
                <CreditPackages />
                
                <div className="mt-12 flex justify-center">
                  <DynamicCreditExplanation maxItems={6} className="w-full" />
                </div>
                
                <div className="mt-6 text-center">
                  <p className="text-sm text-black dark:text-gray-400">
                    Credits never expire and can be used across all AI features. Unused credits roll over month to month.
                  </p>
                </div>
              </TabsContent>
            </Tabs>
          </motion.div>
        </div>
    </div>
  );
};

export default BillingPage;